var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButton212(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 91,
    viewBox: "0 0 212 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_212",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 12,
    width: 201,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 13.4477C75.2884 15.4813 136.089 13.8174 163.6 12.3384C185.952 11.2292 193.785 12.7082 198.561 31.1958C201.236 41.5489 199.708 65.2131 197.797 72.9779C195.505 81.6671 188.436 89.6167 168.376 89.247C150.227 88.8772 83.1213 88.6924 35.933 89.9865C3.83725 91.0958 3.45516 79.8183 1.73574 73.3476C0.0163301 66.8769 -0.938899 40.6245 1.35365 33.0446C7.27607 14.9267 25.9986 12.7082 38.7986 13.4477Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_212)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.00024 12.062H199.443L202 90.062H-0.511617L-1.00024 12.062Z",
    fill: "url(#paint0_linear_bow_button_212)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68259 85.78C-1.5 77.5 -9.43244e-06 59.5 -1.81645e-05 48.3843L37.5216 14.5014C55.7507 14.3599 73.0007 14.201 88.5216 14.0306L8.68259 85.78Z",
    fill: "url(#paint1_linear_bow_button_212)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0452 89C78.6069 88.9793 61.5481 89.7802 43.5552 89.7757L127.91 13.5115C143.571 13.2568 154.678 12.9917 159.331 12.7315C167.422 12.3139 173.829 12.2085 178.978 12.9729L94.0452 89Z",
    fill: "url(#paint2_linear_bow_button_212)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.726 89.094C170.067 89.0165 152.674 89.0551 132.837 89L198.217 32.5825C198.424 33.3247 198.626 34.0928 198.823 34.8877C201 62.5 203 89 173.726 89.094Z",
    fill: "url(#paint3_linear_bow_button_212)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 18.0626C-0.000244141 14.7489 2.68605 12.0626 5.99976 12.0626H194C197.313 12.0626 200 14.7489 200 18.0626V84.0626C200 87.3763 197.313 90.0626 194 90.0626H5.99975C2.68604 90.0626 -0.000244141 87.3763 -0.000244141 84.0626V18.0626Z",
    fill: "url(#paint4_linear_bow_button_212)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.521 23.9993C12.172 25.9974 11.882 29.812 12.027 31.0835C12.172 32.355 14.6364 32.5367 18.1156 31.8101C21.5948 31.0835 23.9143 29.4487 23.1894 26.724C22.3196 22.7278 19.1304 22.9094 16.521 23.9993ZM26.0888 27.4506C26.8136 20.9113 29.8579 20.548 42.1801 22.5461C56.3868 24.9075 61.6056 24.7259 61.7506 25.9974C62.0405 28.1772 54.2123 28.3588 44.6445 28.3588C35.0767 28.3588 25.7988 29.812 26.0888 27.4506Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.13 17.0845C188.819 16.2694 189.052 15.2601 190.878 14.3673C198.877 9.78676 210.45 3.30416 211.77 17.4339C212.081 20.8499 212.12 23.3731 211.615 25.0422C213.673 17.5892 197.441 15.8812 189.13 17.0845Z",
    fill: "url(#paint5_linear_bow_button_212)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.877 14.3674C198.489 10.0198 209.362 3.92533 211.498 15.5707C207.615 11.9218 198.994 13.591 192.353 14.872C190.178 15.1826 189.596 16.1142 189.596 17.007C189.441 17.0458 189.285 17.0458 189.13 17.0847C188.858 16.3083 189.052 15.299 190.877 14.3674Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.615 25.0421C209.906 31.7577 194.644 21.5485 190.217 18.4819C190.217 18.4819 189.44 17.8996 189.169 17.1233C197.44 15.8811 213.867 15.3765 211.615 25.0421Z",
    fill: "url(#paint6_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.13 17.0844C191.305 16.7739 193.48 16.5798 195.654 16.5022C197.829 16.4245 200.043 16.4633 202.179 16.6963C203.266 16.8127 204.353 17.0068 205.402 17.2397C206.45 17.5114 207.499 17.8608 208.47 18.3654C209.441 18.8701 210.334 19.53 210.916 20.4616C211.538 21.3544 211.809 22.4413 211.732 23.5282C211.693 24.0717 211.615 24.6151 211.499 25.1198C211.343 25.6244 211.072 26.129 210.683 26.4784C210.295 26.8278 209.751 27.0218 209.246 27.1383C208.703 27.2159 208.159 27.2159 207.615 27.1771C206.528 27.0607 205.479 26.7501 204.47 26.4008C203.46 26.0514 202.45 25.6244 201.441 25.1586C199.46 24.227 197.557 23.14 195.693 22.0143C193.829 20.8886 192.004 19.6852 190.179 18.4819C193.752 20.9662 197.441 23.3341 201.402 25.2362C202.373 25.702 203.382 26.129 204.431 26.5172C205.479 26.8666 206.528 27.1771 207.615 27.2936C208.159 27.3712 208.703 27.3712 209.246 27.2548C209.79 27.1771 210.334 26.9442 210.761 26.5948C211.188 26.2067 211.46 25.702 211.615 25.1974C211.771 24.654 211.848 24.1105 211.848 23.567C211.887 22.4801 211.615 21.3544 210.994 20.4228C210.373 19.4912 209.479 18.8312 208.509 18.3266C207.538 17.822 206.489 17.4726 205.441 17.2009C204.392 16.9292 203.305 16.7739 202.217 16.6574C197.868 16.1916 193.441 16.4633 189.13 17.0844Z",
    fill: "#FF7E5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.47 18.5599C188.354 17.7447 188.703 16.7743 190.645 16.5025C197.169 15.1827 213.013 14.3287 209.013 25.8965C207.499 30.2829 205.402 32.4567 203.266 32.8061C207.46 30.7488 194.489 20.6173 188.47 18.5599Z",
    fill: "url(#paint7_linear_bow_button_212)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M208.858 26.2456C207.382 19.6466 195.033 17.8609 189.014 17.7833C188.82 17.7833 188.664 17.7833 188.509 17.7833C188.703 17.201 189.286 16.6964 190.606 16.5023C197.13 15.1825 212.974 14.3285 208.974 25.8963C208.936 26.0515 208.897 26.1292 208.858 26.2456Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.227 32.8447C196.508 33.7763 192.275 24.3048 188.897 19.763C188.897 19.763 188.547 19.2196 188.431 18.5597C194.489 20.617 210.294 31.3696 203.227 32.8447Z",
    fill: "url(#paint8_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.47 18.5597C189.324 18.8702 190.179 19.2584 190.994 19.6466C191.81 20.0736 192.625 20.5006 193.441 20.9664C195.033 21.898 196.586 22.8685 198.101 23.9554C199.615 25.0423 201.052 26.168 202.411 27.449C203.071 28.0701 203.693 28.7688 204.236 29.5064C204.508 29.8945 204.741 30.2827 204.858 30.7097C204.974 31.1367 204.974 31.6414 204.702 31.9907C204.431 32.3401 204.003 32.5342 203.576 32.6894C203.46 32.7283 203.343 32.7671 203.227 32.7671C203.11 32.8059 202.994 32.8059 202.877 32.8059C202.644 32.8447 202.411 32.8447 202.178 32.8447C201.246 32.8447 200.353 32.6118 199.499 32.2624C197.829 31.5249 196.431 30.2439 195.227 28.8465C192.78 26.0516 191.033 22.752 188.858 19.7631C189.946 21.277 190.878 22.8685 191.887 24.4212C192.897 25.9739 193.945 27.5266 195.149 28.9241C196.353 30.3215 197.751 31.6025 199.46 32.3789C200.314 32.7671 201.246 32.9612 202.178 33C202.411 33 202.644 33 202.877 32.9612C202.994 32.9612 203.11 32.9224 203.227 32.9224C203.343 32.8835 203.46 32.8835 203.576 32.8447C204.003 32.7283 204.469 32.4954 204.78 32.1072C204.935 31.9131 205.013 31.6802 205.013 31.4473C205.013 31.2144 204.974 30.9814 204.935 30.7485C204.78 30.2827 204.547 29.8945 204.275 29.5064C203.732 28.73 203.11 28.0701 202.411 27.4102C201.052 26.1292 199.576 25.0035 198.062 23.9554C196.547 22.9073 194.994 21.898 193.363 21.0052C192.547 20.5394 191.732 20.1124 190.916 19.7242C190.179 19.2584 189.324 18.8702 188.47 18.5597Z",
    fill: "#FF805E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.256 16.1529C190.877 15.7259 191.266 14.9108 190.45 13.4357C187.77 7.34125 179.11 -6.63323 171.926 3.69236C170.256 6.06026 169.441 8.15643 169.208 9.82561C170.179 1.98437 185.712 11.5336 190.256 16.1529Z",
    fill: "url(#paint9_linear_bow_button_212)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.12 3.42091C179.265 -6.3612 187.77 7.38033 190.45 13.4359C190.954 14.3676 190.954 15.0275 190.799 15.4933C187.459 10.1364 178.644 -0.732606 172.12 3.42091Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.208 9.82565C167.538 18.909 183.887 16.6188 188.819 16.6188C188.819 16.6188 189.673 16.58 190.256 16.153C185.712 11.5336 171.344 -0.499854 169.208 9.82565Z",
    fill: "url(#paint10_radial)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.052 14.9884C186.101 12.1935 182.955 9.5927 179.382 7.61298C177.596 6.64253 175.693 5.78853 173.635 5.67208C172.625 5.63326 171.538 5.90499 170.761 6.60372C169.985 7.30245 169.519 8.2729 169.247 9.24335C168.975 10.2138 168.897 11.3007 169.169 12.31C169.402 13.3192 170.062 14.2121 170.878 14.8331C172.548 16.0753 174.645 16.4635 176.625 16.7352C180.664 17.2399 184.742 16.8129 188.78 16.6188C184.742 16.6964 180.664 17.0846 176.625 16.58C174.645 16.3082 172.587 15.8812 170.955 14.6779C170.179 14.0956 169.557 13.2416 169.324 12.2712C169.091 11.3007 169.169 10.2914 169.441 9.32098C169.713 8.35053 170.14 7.4189 170.878 6.75899C171.616 6.09908 172.625 5.82735 173.635 5.86617C175.654 5.94381 177.557 6.7978 179.344 7.72943C181.13 8.69988 182.8 9.86442 184.392 11.0678C186.023 12.31 187.576 13.591 189.052 14.9884Z",
    fill: "url(#paint11_linear_bow_button_212)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.984 17.5116C190.489 16.9682 190.761 16.153 189.479 15.0661C185.867 11.456 172.237 1.28573 170.916 12.2712C170.411 16.58 170.8 19.3749 172.198 20.7335C169.208 15.3766 184.935 16.2306 189.984 17.5116Z",
    fill: "url(#paint12_linear_bow_button_212)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M170.877 12.7372C170.877 12.5819 170.916 12.4266 170.916 12.2325C172.237 1.24703 185.867 11.4173 189.479 15.0274C190.333 15.765 190.489 16.3472 190.333 16.8519C185.013 13.9017 175.421 9.94227 170.877 12.7372Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.198 20.6945C175.693 24.4986 184.47 19.9181 189.052 18.1325C189.052 18.1325 189.596 17.8996 189.984 17.5114C184.936 16.2304 168.082 15.4541 172.198 20.6945Z",
    fill: "url(#paint13_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M189.984 17.5114C188.275 17.0844 186.528 16.8903 184.78 16.735C183.033 16.5797 181.246 16.5021 179.499 16.5409C177.751 16.5797 175.965 16.6962 174.256 17.1232C173.829 17.2396 173.402 17.3561 173.014 17.5502C172.625 17.7443 172.198 17.9772 171.926 18.3266C171.771 18.4818 171.654 18.7147 171.616 18.9477C171.577 19.1806 171.577 19.4135 171.616 19.6464C171.732 20.1122 171.965 20.5004 172.237 20.8497C172.742 21.3932 173.441 21.8202 174.14 22.0531C174.878 22.286 175.615 22.3636 176.353 22.3248C177.868 22.286 179.344 21.9366 180.78 21.5096C182.217 21.0826 183.615 20.5392 185.013 19.9569C186.411 19.3746 187.771 18.7535 189.13 18.2101C187.732 18.7535 186.373 19.3358 184.975 19.9181C183.576 20.4615 182.178 21.005 180.742 21.432C179.305 21.859 177.829 22.1696 176.353 22.2084C175.615 22.2084 174.878 22.1307 174.14 21.8978C173.441 21.6649 172.781 21.2767 172.276 20.7333C172.004 20.3839 171.771 19.9957 171.693 19.6076C171.577 19.1806 171.693 18.7536 172.004 18.443C172.276 18.1325 172.664 17.8996 173.052 17.7055C173.441 17.5114 173.868 17.3949 174.295 17.2785C176.004 16.8515 177.751 16.735 179.499 16.6962C181.246 16.6574 183.033 16.735 184.78 16.8515C186.489 16.9291 188.275 17.1232 189.984 17.5114Z",
    fill: "#FE7758"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M186.411 10.8347C189.207 8.69976 193.285 11.7276 193.285 11.7276C195.382 13.8625 188.12 17.2009 190.217 21.8591C190.217 21.8591 184.819 21.8202 183.343 17.7832C182.877 12.8921 186.411 10.8347 186.411 10.8347Z",
    fill: "url(#paint14_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_212",
    x1: 101.46,
    y1: 90.0619,
    x2: 101.515,
    y2: 12.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403315,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674033,
    stopColor: "#F98F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779006,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E90202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_212",
    x1: -85.8111,
    y1: 50.178,
    x2: -80.2222,
    y2: 83.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_212",
    x1: -85.8111,
    y1: 50.178,
    x2: -80.2222,
    y2: 83.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_212",
    x1: -85.8111,
    y1: 50.178,
    x2: -80.2222,
    y2: 83.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_212",
    x1: 190.198,
    y1: 7.35575,
    x2: 89.7698,
    y2: 74.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bow_button_212",
    x1: 212.606,
    y1: 17.4,
    x2: 189.217,
    y2: 14.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.366 21.4322) rotate(-173.566) scale(8.94432 8.94071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_bow_button_212",
    x1: 207.99,
    y1: 27.1637,
    x2: 190.079,
    y2: 15.4621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.793 27.7877) rotate(-163.52) scale(11.3361 11.3321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    stopColor: "#A50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#7D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#650000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_bow_button_212",
    x1: 171.676,
    y1: 3.69061,
    x2: 191.63,
    y2: 13.8285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.346 13.4076) rotate(26.9141) scale(8.55389 8.55175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#610000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_bow_button_212",
    x1: 189.155,
    y1: 15.3711,
    x2: 169.165,
    y2: 9.45255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6713,
    stopColor: "#FF704C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    stopColor: "#FF7C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF805E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_bow_button_212",
    x1: 170.121,
    y1: 14.3295,
    x2: 187.185,
    y2: 12.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.961 27.8719) rotate(170.053) scale(16.8576 16.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#980000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9247,
    stopColor: "#580000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#4F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.488 3.3914) rotate(-147.039) scale(18.7851 18.7819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#F51911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6485,
    stopColor: "#FF453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#FF876E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    stopColor: "#F63636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BA1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9758,
    stopColor: "#890D01"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton212);
export default __webpack_public_path__ + "static/media/button-212.2c859c70.svg";
export { ForwardRef as ReactComponent };